import { DEFAULT_CURRENCY, getCurrencyFractionDigits } from "../config/countries";

/**
 * Montant formaté (« 2 000 F CFA », « 2 000,00 NGN »). Sans devise, XOF.
 * Les décimales viennent du référentiel src/config/countries.js ;
 * `trimIntegerDecimals` affiche « €10 » plutôt que « €10.00 ».
 */
export const formatMoney = (amount, currency, { locale = "fr-FR", trimIntegerDecimals = false } = {}) => {
    if (amount === null || amount === undefined || amount === "") {
        return "—";
    }
    const value = Number(amount);
    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency || DEFAULT_CURRENCY,
            maximumFractionDigits: getCurrencyFractionDigits(currency),
            ...(trimIntegerDecimals && Number.isInteger(value) ? { minimumFractionDigits: 0 } : {})
        }).format(value);
    } catch {
        return `${amount} ${currency || ""}`.trim();
    }
};
